import React from 'react'

class SelectInput extends React.Component {

	render() {
		return (
			<div className="form-group">
			<div className="styled-select clearfix">
		        <select id = {this.props.id} required className="wide" value={this.props.selection} >
		            <option selected disabled hidden>{this.props.question}</option>
			        {
			            this.props.question_options.map((option, index) => {
			              return (<option key={index} value={option.id} >{option.text}</option>)
			        	}
		        	)}
		        </select>
		        {this.props.required ? <span className="error">Required</span> : false}
		    </div>
		    </div>
		);
	}
}

export default SelectInput


// WEBPACK FOOTER //
// ./src/components/SelectInput.js